export const MAX_NUMBER_OF_OTPS = 100;
